export default __webpack_public_path__ + "static/media/FOUR2x.c61e9b5f.jpg";